import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useScrollVisibility } from "@/hooks/useScrollVisibility";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { findCategoryItem, getParentIds } from "../../utils/categoryTree";
import { CategoryLNBHeader } from "./CategoryLNBHeader";
import { LNBItem } from "./LNBItem";
import { MiniFreeTrialModule } from "./MiniFreeTrialModule";
/** LNB 스켈레톤 컴포넌트 - 실제 LNB 레이아웃과 동일 */ const CategoryLNBSkeleton = ()=>/*#__PURE__*/ _jsxs("nav", {
        className: "flex w-50 flex-col gap-4 bg-white py-6 lg:w-60",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "h-7 w-32 animate-pulse rounded bg-gray-200"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "min-h-10 rounded-sm bg-gray-50 px-2 py-2",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "h-5 w-24 animate-pulse rounded bg-gray-200"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "size-3 animate-pulse rounded bg-gray-200"
                                })
                            ]
                        })
                    }),
                    Array.from({
                        length: 3
                    }).map((_, index)=>/*#__PURE__*/ _jsx("div", {
                            className: "min-h-10 px-2 py-2",
                            style: {
                                marginLeft: "12px"
                            },
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "h-4 animate-pulse rounded bg-gray-100",
                                style: {
                                    width: "".concat(60 + index * 10, "%")
                                }
                            })
                        }, "2depth-".concat(index))),
                    Array.from({
                        length: 4
                    }).map((_, index)=>/*#__PURE__*/ _jsx("div", {
                            className: "min-h-10 px-2 py-2",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "h-5 animate-pulse rounded bg-gray-100",
                                        style: {
                                            width: "".concat(50 + index * 8, "%")
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "size-3 animate-pulse rounded bg-gray-100"
                                    })
                                ]
                            })
                        }, "1depth-".concat(index)))
                ]
            })
        ]
    });
export const CategoryLNB = (param)=>{
    let { title , titleHref , items , selectedCategoryId , onCategorySelect , freeTrialModule , depthCategories , currentDepthCategoryId , onDepthCategoryChange , isLoading , pageType ="edition"  } = param;
    const [expandedIds, setExpandedIds] = useState(new Set());
    // 페이지 스크롤 감지 - 100px 이상 스크롤 시 미니 무료 모듈 노출
    const isAtTop = useScrollVisibility({
        mode: "top",
        topThreshold: 100
    });
    const showFreeTrialModule = !isAtTop;
    // selectedCategoryId 변경 시 부모들 자동 펼침
    useEffect(()=>{
        var _selectedItem_items;
        if (!selectedCategoryId || isLoading) return;
        const parentIds = getParentIds(selectedCategoryId, items);
        const newExpandedIds = new Set(parentIds);
        // 선택된 카테고리 자체도 하위 항목이 있으면 펼침
        const selectedItem = findCategoryItem(selectedCategoryId, items);
        if (selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem_items = selectedItem.items) === null || _selectedItem_items === void 0 ? void 0 : _selectedItem_items.length) {
            newExpandedIds.add(selectedCategoryId);
        }
        setExpandedIds(newExpandedIds);
    }, [
        selectedCategoryId,
        items,
        isLoading
    ]);
    const handleToggle = (categoryId)=>{
        setExpandedIds((prev)=>{
            const next = new Set(prev);
            if (next.has(categoryId)) {
                next.delete(categoryId);
            } else {
                next.add(categoryId);
            }
            return next;
        });
    };
    // 로딩 중이면 스켈레톤 표시
    if (isLoading) {
        return /*#__PURE__*/ _jsx(CategoryLNBSkeleton, {});
    }
    return /*#__PURE__*/ _jsxs("nav", {
        className: "flex w-50 flex-col gap-4 bg-white py-6 lg:w-60",
        children: [
            /*#__PURE__*/ _jsx(CategoryLNBHeader, {
                title: title,
                titleHref: titleHref,
                depthCategories: depthCategories,
                currentDepthCategoryId: currentDepthCategoryId,
                onDepthCategoryChange: onDepthCategoryChange
            }),
            freeTrialModule && /*#__PURE__*/ _jsx("div", {
                className: cn("grid transition-all duration-200 ease-out", showFreeTrialModule ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0 -mt-4"),
                children: /*#__PURE__*/ _jsx("div", {
                    className: "overflow-hidden",
                    children: /*#__PURE__*/ _jsx(MiniFreeTrialModule, {
                        ...freeTrialModule
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-col overflow-y-auto",
                children: items.map((item)=>/*#__PURE__*/ _jsx(LNBItem, {
                        item: item,
                        depth: 1,
                        selectedCategoryId: selectedCategoryId,
                        expandedIds: expandedIds,
                        onSelect: onCategorySelect,
                        onToggle: handleToggle,
                        pageType: pageType
                    }, item.categoryId))
            })
        ]
    });
};
export default CategoryLNB;
